import {
  Button,
  buttonVariants,
  FieldLabel,
  FormDescription,
  FormHeading,
  HtmlButtonLink,
  PageMainContent,
  useGoBack,
  cn,
  Divider,
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogClose,
  

} from "@vixi/ui";
import { useTranslation } from "@vixi/localization";
import { Img, TextArea } from "@vixi/ui";
import { RouteOptionsById, RouterIds, Link } from "@vixi/router";
import { ComponentProps, useState } from "react";

const routeId = "/_app/chat/" satisfies RouterIds;

export const ChatIndexPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};
const ManageCourseCard = (props: ComponentProps<"div">) => (
  <div
    {...props}
    className={cn(
      "bg-paper flex w-[638px] items-center ps-5.5 gap-6.25 rounded max-h-[81px] hover:border-primary border-2 border-transparent transition-all duration-300 ",
      props.className,
    )}
  />
);


function RouteComponent() {
  useGoBack(null);
  const { t, tFile, isRtl } = useTranslation();
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  return (
    <PageMainContent scrollable ps="medium">
      <div className="bg-white  rounded flex items-center justify-between">
        <FormHeading heading="ContactUs.Title">
          <FormDescription >
            {t("ContactUs.Subtitle")}
          </FormDescription>
        </FormHeading>
        <img src="/images/chat.webp" alt="Chat" className="w-[95px] h-[84px]  me-7.5" />
      </div>
     
      <div className="flex  pt-7.5 flex-col gap-y-7.5 items-center h-full w-full`">
        <Link to='https://vixiapp.gitbook.io/vixi-course-maker/~/changes/2'
          target="_blank"
          >
          <ManageCourseCard className="relative">
            <img src="/images/help.svg" alt="" className="h-[59px] w-[59px]" />

            <div className="flex flex-col items-start">
              <h2

                className="text-[#334D6E] text-[20px] font-bold mt-3.5"

              >
                {t("chat.helpCenter")}
              </h2>

              <p className="mb-4.5">{t("chat.helpCenterDescription")}</p>
            </div>
            <img src="/images/icons/rightarrow.png" alt="" className={cn("absolute top-[50%] translate-y-[-50%]", isRtl ? "left-6.25" : "right-6.25")} />


          </ManageCourseCard>
        </Link>
        <Link to='https://calendly.com/alzahabi-vixiapp/30min'
          target="_blank"
          >
          <ManageCourseCard className="relative">
            <img src="/images/demo.svg" alt="" className="h-[59px] w-[59px]" />

            <div className="flex flex-col items-start">
              <h2

                className="text-[#334D6E] text-[20px] font-bold mt-3.5"

              >
                {t("ContactUs.BookDemo")}
              </h2>

              <p className="mb-4.5">{t("chat.bookDemoDescription")}</p>
            </div>
            <img src="/images/icons/rightarrow.png" alt="" className={cn("absolute top-[50%] translate-y-[-50%]", isRtl ? "left-6.25" : "right-6.25")} />


          </ManageCourseCard>
        </Link>
        <Dialog open={isContactDialogOpen} onOpenChange={setIsContactDialogOpen}>
          <DialogTrigger asChild>
            <ManageCourseCard className="relative cursor-pointer">
              <img src="/images/contact.svg" alt="" className="h-[59px] w-[59px]" />

              <div className="flex flex-col items-start">
                <h2

                  className="text-[#334D6E] text-[20px] font-bold mt-3.5"

                >
                  {t("chat.contactUs")}
                </h2>

                <p className="mb-4.5">{t("chat.contactUsDescription")}</p>
              </div>
              <img src="/images/icons/rightarrow.png" alt="" className={cn("absolute top-[50%] translate-y-[-50%]", isRtl ? "left-6.25" : "right-6.25")} />


            </ManageCourseCard>
          </DialogTrigger>
          <DialogContent className="max-w-[400px] text-center" showCloseButton={false}>
            <div className="flex flex-col items-center gap-4 py-4">
              <div className="relative w-24 h-24 flex items-center justify-center">
                {/* 3D Envelope Icon - Open yellow envelope with white letter and purple @ */}
                <img src="/images/contact.svg" alt="" className="w-24 h-24" />
              </div>
              <p 
                className="text-[#334D6E] text-base leading-relaxed px-2"
                dangerouslySetInnerHTML={{
                  __html: t("chat.contactUsDialogMessage").replace(
                    /\*\*(.*?)\*\*/g,
                    '<span class="text-[#D97706] font-semibold">$1</span>'
                  )
                }}
              />
              <DialogClose asChild>
                <Button 
                className="py-3 px-13.75 "
                  onClick={() => setIsContactDialogOpen(false)}
                >
                  {t("chat.okay")}
                </Button>
              </DialogClose>
            </div>
          </DialogContent>
        </Dialog>
      </div>
  
    </PageMainContent>
  );
}
